module.exports = __webpack_public_path__ + "img/blessing.bf38c684.gif";